import { observer } from 'mobx-react-lite';
import { Alert, Button, CircularProgress, Stack, TextField, Typography } from '@mui/material';

import { useRootStore } from 'stores/RootStore';
import { CenteredFormPage } from 'components/CenteredFormPage';

import { LinkButton } from 'components/shared/LinkButton';

const RequestAccessPage = observer(() => {
  const { requestAccessPageStore, routeStore, diligencePageStore } = useRootStore();
  const { navigateByName } = routeStore;
  const { diligenceStore } = diligencePageStore;
  const job = diligenceStore?.job;
  const { form, status, errorMessage, requestAccess } = requestAccessPageStore;

  return (
    <CenteredFormPage>
      <form>
        <Stack spacing={2} sx={{ margin: '32px 0' }}>
          {status !== 'sent' && (
            <Typography variant="h3" textAlign="center" style={{ marginBottom: errorMessage ? undefined : '32px' }}>
              <strong>You need access</strong>
            </Typography>
          )}
          {status === 'error' && <Alert severity="error">{errorMessage}</Alert>}
          {status === 'sending' && <CircularProgress sx={{ marginTop: '24px', alignSelf: 'center' }} />}
          {(status === 'not sent' || status === 'error') && (
            <>
              <TextField
                variant="outlined"
                autoComplete="off"
                data-testid="message"
                placeholder={`Hello! I'd like to get an access to job ${job?.name}`}
                multiline
                rows={4}
                {...form.$('message').bind()}
              />
              <Button
                variant="contained"
                disableElevation
                disabled={!form.isValid}
                style={{ height: 56 }}
                onClick={async () => {
                  await requestAccess();
                }}
              >
                Request access
              </Button>
              <Typography variant="body1" textAlign="center">
                OR
              </Typography>
              <LinkButton aria-label="jobs" onClick={() => navigateByName('jobs')}>
                View Jobs
              </LinkButton>
            </>
          )}
          {status === 'sent' && (
            <>
              <Typography variant="h6" textAlign="center" color="green">
                Request was sent to production appraiser!
              </Typography>
              <Typography variant="h6" textAlign="center">
                You will receive an email notification once your request is approved.
              </Typography>
              <LinkButton aria-label="jobs" onClick={() => navigateByName('jobs')}>
                View Jobs
              </LinkButton>
            </>
          )}
        </Stack>
      </form>
    </CenteredFormPage>
  );
});

export { RequestAccessPage };
